module.exports = __webpack_public_path__ + "img/HQ-Z7020-V2.0f536f68.jpg";